/**
 * 用法示例
 *
 *
 *
 * EnumsHelper.EUseStatus._list  //获取枚举项 return [{key,val,desc}]
 *
 * EnumsHelper.EUseStatus.NotUsed   // 未使用 状态 return 1
 *
 * EnumsHelper.EUseStatus._desc(1) //未使用 状态 return 未使用
 *
 *
 */

function init(data) {
  let _enumsHelper = {};
  class Enums {
    /**
     *  _name:'枚举名称'
     *  _enum:[{key,val,desc}]
     */
    constructor(_name, _enum) {
      this._name = _name;
      this._list = _enum;
     
      function _init() {
        if (this._list.length) {
          this._list.forEach(item => {          
            item.val = parseInt(item.val);
            this[item.key] = item.val;
          });
        }
      }
      _init.call(this);
      
      return this;
    }
    /**
     * 根据Val 获取枚举项
     */
    _val(_val) {
      return (
        (this._list.length && this._list.find(t => t.val == _val)) || undefined
      );
    }
    _desc(_val) {
      var t;
      return (
        (this._list.length && (t = this._list.find(t => t.val == _val)),
        t && t.desc) || ""
      );
    }
  }

  if (data) {
    for (var i in data) {
      _enumsHelper[i] = new Enums(i, data[i]);
    }
    return _enumsHelper;
  }
  return {};
}

export function _EnumInit(data) {
  return init(data);
}



// WEBPACK FOOTER //
// ./utils/enumHelper.js